import type { ApiModuleEndpoints } from '../types'

export const paymentMethodApiEndpoints = {
  list: {
    method: 'GET',
    path: '/payment-methods',
    requiresAuth: true,
  },
  options: {
    method: 'GET',
    path: '/payment-methods/options',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/payment-methods/:id',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/payment-methods',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/payment-methods/:id',
    requiresAuth: true,
  },
  delete: {
    method: 'DELETE',
    path: '/payment-methods/:id',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
